import supabase from "../../utils/supabase";
import {
  AnalyticsFetchContext,
  fetchWithApiError,
} from "./analyticsFetch";

export async function authenticatedFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
  context?: AnalyticsFetchContext
): Promise<Response> {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();

  if (error || !session?.access_token) {
    throw new Error("Authentication required");
  }

  const headers = new Headers(init?.headers);
  headers.set("Authorization", `Bearer ${session.access_token}`);

  return fetchWithApiError(
    input,
    {
      ...init,
      headers,
    },
    context
  );
}
